import {
    CHAT_IA_INIT,
    CHAT_IA_SUCCESS,
    CHAT_IA_GET_HISTORICO_INIT,
    CHAT_IA_GET_HISTORICO_SUCCESS,
    ERROR_CHAT_IA,
    CLEAR_CHAT_IA
} from '../actionTypes';

export const chatIaInit = (data: any) => ({
    type: CHAT_IA_INIT,
    payload: data
});

export const chatIaSuccess = (data: any) => ({
    type: CHAT_IA_SUCCESS,
    payload: data
});

export const chatIaGetHistoricoInit = (userId: string) => ({
    type: CHAT_IA_GET_HISTORICO_INIT,
    payload: userId
});

export const chatIaGetHistoricoSuccess = (data: any) => ({
    type: CHAT_IA_GET_HISTORICO_SUCCESS,
    payload: data
});

export const chatIaError = (data: any) => ({
    type: ERROR_CHAT_IA,
    payload: data
});

export const chatIaCleanUp = () => ({
    type: CLEAR_CHAT_IA
});
